import type {
  CreateDefenderInput,
  Defender,
  OperationalAsset,
  UpdateDefenderInput,
} from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/**
 * Actions de gestion de la flotte défensive (ADR-0040, C3) consommées par l'IHM opérationnelle.
 * Fonctions pures côté réseau (pas d'état React) : l'appelant déclenche, puis rafraîchit la situation.
 * L'autorisation (EDITOR+) est portée par l'API — l'IHM ne fait que masquer les contrôles aux autres.
 */

/** Matériels DRONE/UGV rattachables comme défenseurs (non déjà rattachés). */
export function fetchDefenderCandidates(): Promise<OperationalAsset[]> {
  return apiFetch<OperationalAsset[]>('/ops/defender-candidates');
}

/** Rattache un matériel comme défenseur d'une zone. */
export function attachDefender(zoneId: string, body: CreateDefenderInput): Promise<Defender> {
  return apiFetch<Defender>(`/ops/zones/${zoneId}/defenders`, { method: 'POST', body });
}

/** Met à jour l'état et/ou la position d'un défenseur. */
export function updateDefender(defenderId: string, body: UpdateDefenderInput): Promise<Defender> {
  return apiFetch<Defender>(`/ops/defenders/${defenderId}`, { method: 'PATCH', body });
}

/** Retire un défenseur de la vue opérationnelle (le matériel reste en flotte). */
export function removeDefender(defenderId: string): Promise<void> {
  return apiFetch<void>(`/ops/defenders/${defenderId}`, { method: 'DELETE' });
}
